// @flow
import React, { PureComponent } from 'react';
import { Wrap, Name, Input, SliderWrap, SliderStyled } from './Slider.styled';

type Props = {
  name: string,
  value: number,
  min: number,
  max: number,
  onChange: () => void,
};

class MySlider extends PureComponent<Props> {
  state = {};

  handleInputChange = e => {
    if (e.target.value === '') {
      this.props.onChange(e, e.target.value);
    } else {
      // eslint-disable-next-line prefer-destructuring
      const value = +e.target.value;
      // eslint-disable-next-line no-restricted-globals
      if (!isNaN(value)) {
        if (
          (this.props.min !== undefined && this.props.min > value) ||
          (this.props.max !== undefined && this.props.max < value)
        )
          return;
        this.props.onChange(e, value);
      }
    }
  };

  render() {
    const { name, value, ...rest } = this.props;
    return (
      <Wrap>
        <Name>{name}</Name>
        <SliderWrap>
          <SliderStyled {...rest} value={value} />
          <Input {...rest} value={value} onChange={this.handleInputChange} />
        </SliderWrap>
      </Wrap>
    );
  }
}

export default MySlider;



// WEBPACK FOOTER //
// /opt/build/repo/src/app/components/Slider/Slider.js